// extracted by mini-css-extract-plugin
export default {"container":"marcadoresMapa_container__3BPpT","mapContainer":"marcadoresMapa_mapContainer__momUd","loadingMessage":"marcadoresMapa_loadingMessage__0JtXw"};